import { Action, ActionCreator } from '@ngrx/store';
import { CheckedError } from '@app/core/errors/errors/checked-error.interface';

/**
 * Creates a key for the 'execute' type.
 *
 * @param key The base key.
 * @param action The action that the key is being created for.
 */
export const executeKey: (type: string, action?: string) => string = (key: string, action?: string) =>
  action ? `${key}#${action}` : key;

/**
 * Creates a key for the success type.
 *
 * @param key The base key.
 * @param action The action that the key is being created for.
 */
export const successKey: (type: string, action?: string) => string = (key: string, action?: string) =>
  `${executeKey(key, action)}#success`;

/**
 * Creates a key for the completed type.
 *
 * @param key The base key.
 * @param action The action that the key is being created for.
 */
export const completedKey: (type: string, action?: string) => string = (key: string, action?: string) =>
  `${executeKey(key, action)}#completed`;

/**
 * Creates a key for the failure type.
 *
 * @param key The base key.
 * @param action The action that the key is being created for.
 */
export const failureKey: (type: string, action?: string) => string = (key: string, action?: string) =>
  `${executeKey(key, action)}#failure`;

/**
 * A reusable type for execute actions.
 */
export type ExecuteType<T extends string, Key> = ActionCreator<
  T,
  (props: { request: Key }) => { request: Key } & Action<T>
>;

/**
 * A reusable type for failed actions.
 */
export type FailureType<T extends string> = ActionCreator<
  T,
  (props: { error: CheckedError }) => { error: Error } & Action<T>
>;
